// front/src/components/layout/Sidebar/Sidebar.styles.js
import styled from 'styled-components';

export const SidebarContainer = styled.div`
  width: ${({ collapsed }) => collapsed ? '60px' : '300px'};
  height: calc(100vh - 55px); /* Altura total menos a altura do Navbar */
  background-color: #f0f3f5;
  position: fixed;
  left: 0;
  top: 55px; /* Começa abaixo do Navbar */
  display: flex;
  flex-direction: column;
  padding-top: 25px;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  z-index: 10;
  transition: width 0.3s ease;

  @media (max-width: 768px) {
    width: ${({ collapsed }) => collapsed ? '60px' : '150px'};
    top: 50px; /* Ajuste para altura menor do Navbar em mobile */
    height: calc(100vh - 50px);
    padding-top: 20px;
  }

  @media (max-width: 480px) {
    top: 50px;
    height: calc(100vh - 50px);
    padding-top: 15px;
  }
`;

export const MenuItem = styled.div`
  display: flex;
  align-items: center;
  padding: 7.5px 20px;
  color: ${({ disabled }) => disabled ? '#999' : '#2c3e50'};
  font-size: 0.9rem;
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.2s ease;
  font-weight: bold;
  width: 100%;
  position: relative;
  padding-left: ${({ level }) => 20 + (level * 20)}px;
  background-color: ${({ active }) => active ? 'rgba(106, 184, 168, 0.6)' : 'transparent'};
  border-bottom: 1px solid #f0f3f5;
  opacity: ${({ disabled }) => disabled ? 0.5 : 1};

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 20px;
    right: 20px;
    height:1.5px;
    background-color: #ddd;
  }

  &:hover {
    background-color: ${({ disabled }) => disabled ? 'transparent' : 'rgba(106, 184, 168, 0.6)'};
  }

  .material-symbols-outlined {
    margin-right: 8px;
    font-size: 28px;
    flex-shrink: 0;
    
    &.rotated {
      transform: rotate(180deg);
      margin-left: auto;
      margin-right: 0;
    }
  }

  .sidebar-custom-icon {
    width: 28px;
    height: 28px;
    margin-right: 8px;
    flex-shrink: 0;
    object-fit: contain;
  }

  @media (max-width: 768px) {
    font-size: 0.9rem;
    padding: 8px 15px;
  }

  @media (max-width: 480px) {
    font-size: 0.8rem;
    padding: 6px 10px;
  }
`;

export const SubMenu = styled.div`
  display: ${({ isVisible }) => (isVisible ? "block" : "none")};
  margin-top: 5px;
  font-size: 0.7rem;

  & > a {
    text-decoration: none;
    color: #6AB8A8;

    &:hover {
      color: #6AB8A8;
    }
  }

  & > a > div {
    padding-top: 12px;
    font-size: 0.7rem;
    padding-left: 50px;
    background-color: transparent;
    width: calc(100% - 0px);
  }
`;

export const MenuText = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;